<template>
	<menu-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
		<template v-slot:activator = "{ on }">
			<v-list-item v-on = "on" @click.stop.prevent = 'visibility = !visibility; getPersons();'>
				<v-list-item-action>
	                <v-btn color = 'light-blue lighten-2' depressed icon small><v-icon>add</v-icon></v-btn>
	            </v-list-item-action>
				<v-list-item-content class = 'text-left font-weight-regular'>
	            	<v-list-item-title>Добавить пользователя</v-list-item-title>
	            </v-list-item-content>
                <v-list-item-action>
	            </v-list-item-action>
			</v-list-item>
		</template>
        <template v-slot:title>Назначить пользователя</template>
        <template v-slot:content>
			<v-form class = 'mx-4'>
				<v-select
					v-model = 'user.mode_edit'
					:items = "modeReport"
					item-text = "text"
					item-value = "value"
					label = "Содержимое отчета"
					hint = 'Доступ к отчету'
					persistent-hint
					single-line
					:rules = "[rules.required]"
				></v-select>
				<v-select
					v-model = 'user.mode_persons'
					:items = "modePersons"
					item-text = "text"
					item-value = "value"
					label = "Пользователи отчета"
					hint = 'Доступ к пользователям отчета'
					persistent-hint
					single-line
					:rules = "[rules.required]"
				></v-select>
				<v-text-field
					v-model = 'user.mode_name'
					label = 'Отображаемое название роли'
					counter = '40'
					:rules = '[rules.length, rules.required]'
				></v-text-field>
				<v-text-field
					v-model = 'user.mode_description'
					label='Отображаемое описание роли'
				></v-text-field>
				<v-checkbox 
					v-model = 'set_expiration'
					class = 'my-0 py-0 mb-4'
					hide-details
				>
					<template v-slot:label>
						<span class = 'ml-1'>Назначить <b>срок действия</b> доступов</span>
					</template>
				</v-checkbox>
				<v-menu 
					v-if = 'set_expiration'
                    ref = "selectedDate" 
                    :close-on-content-click = "false" 
                    :return-value.sync = "user.expire_on" 
                    offset-y 
                    v-model = 'selectedDate'
                >
                    <template v-slot:activator = '{ on }'>
                        <v-text-field 
                            v-on = 'on' 
                            v-model = 'user.expire_on' 
                            clearable 
                            label = 'Окончание срока действия'
                        ></v-text-field>
                    </template>
                    <v-date-picker 
                        :rules = "[rules.required]" 
                        style = 'width: 100%;' 
                        :header-color = '$store.getters.uiAccent' 
                        v-model = 'user.expire_on' 
                        @input = "$refs.selectedDate.save(user.expire_on)" 
                        locale = 'ru-ru' 
                        :min = 'min_expiration'
                        first-day-of-week='1'
                    ></v-date-picker>
                </v-menu>
				<v-autocomplete
					v-model = 'user.uid'
					:items = 'users'
					:loading = 'indicatorSecondary'
					hide-no-data
					hide-selected
					item-text = 'placeholder'
					item-value = 'uid'
					label = 'Сотрудники компании'
					placeholder = 'Начните вводить имя сотрудника'
					:rules = "[rules.required]"
					:error = 'errorAccess'
		  	   		:error-messages = 'errorAccessMessage'
					@keyup = 'errorAccess=false;errorAccessMessage=[];'
			    ></v-autocomplete>
			</v-form>
        </template>
        <template v-slot:action>
            <v-btn class = 'px-0 light-blue--text text--darken-2' :loading = 'indicator' block depressed @click = 'addReportPerson'>Добавить</v-btn>
        </template>
    </menu-generic>
</template>

<script>
	import { orderBy } from 'lodash-es'
	import MenuGeneric from '@/components/elements/menus/Generic.vue'
	import dayjs from 'dayjs'
	
	export default {
		name: 'UserReportCreateMenu',
		props: ['postAction', 'report'],
		components: {MenuGeneric},
		data() {
			return {
				users: [],
		        modeReport: [
		        	{'text':'Просмотр отчета','value':'R'},
		          	{'text':'Изменение и обновление отчета','value':'W'}
		        ],
		        modePersons: [
		        	{'text':'Нет доступа к списку пользователей','value':'R'},
		          	{'text':'Просмотр списка пользователей','value':'W'},
		          	{'text':'Управление списком пользователей','value':'X'}
		        ],
				visibility: false,
				user: {},
				set_expiration: false,
				selectedDate: false,
				min_expiration: dayjs().add(1, 'day').format('YYYY-MM-DD'),
				indicator: false,
				errorAccess: false,
				errorAccessMessage: '',
				indicatorSecondary: false,
				rules: {
					required: value => !!value || 'Обязательное поле.',
					length: value => (value && value.length <= 40) || 'Не длинее 40 символов'
				}
			}
		},
		methods: {
			getPersons() {
	    		this.indicatorSecondary = true;
	    		this.$http.get(this.$store.getters.endpoint + '/db/persons', {
		          emulateJSON: true,
		          params: {'login': this.$store.getters.userLogin},
		          headers: {...this.$store.state.restrictedHeaders,...{'Authorization': 'Bearer ' + this.$store.getters.userToken}}
		        }).then( (r) => {
		          let response = r.body;
		          if (response.result) {
		          	this.indicatorSecondary = false;
		            this.users = response.data.filter( (u) => u.domain == this.$store.state.brandingOption || u.domain == '*')
		            this.users.map( (e) => { e.placeholder = e.name + ' ' + e.lastname})
		            this.users = orderBy(this.users, 'placeholder');
		          } else {
		            console.log(response)
		          }
		        })
	    	},
			addReportPerson() {
				this.indicator = true;
		        let requestHeaders = {
		          'Content-Type': 'application/json;charset=UTF-8',
		          'Authorization': 'Bearer ' + this.$store.getters.userToken
		        }
			    this.$http.post(this.$store.getters.endpoint + '/db/reports/persons', {
			        ...{'login': this.$store.getters.userLogin, 'report_id': this.report.report_id},...this.user
			        },{
			            headers: {...this.$store.state.restrictedHeaders,...requestHeaders
			        }
			    }).then( (r) => {
			        let response = r.body;
			        if (response.result) {
						this.indicator = false;
						this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'create',
                                target: 'report_user'
                            },
                            once: false
                        })
			            this.postAction();
			            this.visibility = false;
			        } else {
			            console.log(response)
			        }
			    }, (r) => {
			    	this.indicator = false;
			    	let error = r.body;
	        		console.log(error)
	        		if (error.reason == 'Access exists') {
		        		this.errorAccess = true;
		        		this.errorAccessMessage = ['Пользователь уже имеет доступ к отчету с уровнем ' + this.modeReport.filter((m) => m.value == error.data[0].role_id)[0].text]
		        	}
			    });
			}
		}
	}
</script>